import type { StorageValue } from "./storage-type";

export const clear = (): void => {
  localStorage.clear();
};
export const get = (key: string): string | null => localStorage.getItem(key);
export const has = (key: string): boolean => (get(key) ? true : false);
export const keys = (): string[] => {
  const keys: string[] = [];

  for (let index = 0; index < localStorage.length; index++) {
    const key: string | null = localStorage.key(index);

    if (key) {
      keys.push(key);
    }
  }
  return keys;
};
export const remove = (key: string): void => {
  localStorage.removeItem(key);
};
export const set = (key: string, value: StorageValue): void => {
  const serializedValue: string =
    typeof value === "object" ? JSON.stringify(value) : String(value);
  localStorage.setItem(key, serializedValue);
};
export const update = (key: string, value: StorageValue): void => {
  if (get(key)) {
    set(key, value);
  }
};
